<template>
  <div :class="divider ? '' : 'margin'"
       class="details-section">

    <div v-if="title"
         class="details-section-title">
      <div class="title-main">
        <span class="primary--text section-name">{{ title }}</span>
        <span v-if="editable"
              class="edit-btn"
              @click="$emit('edit')">bearbeiten</span>
        <span v-if="alternativelink"
              class="edit-btn"
              @click="navigateAlternativeLink">{{ alternativelink.text }}</span>
      </div>
      <div v-if="hinttext"
           class="mt-3 hint secondary--text">
        {{ hinttext }}
      </div>

    </div>

    <label-value-table v-if="items.length > 0"
                       :items="items">
      <template v-if="valueSlotUsed()"
                slot="value"
                slot-scope="{ item }">
        <slot :item="item"
              name="value" />
      </template>
    </label-value-table>

    <v-divider v-if="divider"
               class="profile-divider" />

  </div>
</template>
<script>
import LabelValueTable from "@/components/userProfile/LabelValueTable";

export default {
  name: "DetailsSection",
  components: { LabelValueTable },
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    divider: {
      type: Boolean,
      default: false
    },
    alternativelink: {
      type: Object,
      default: undefined
    },
    hinttext: {
      type: String,
      default: null,
      required: false
    }
  },
  methods: {
    navigateAlternativeLink() {
      if (this.alternativelink.newPage === true) {
        const routeData = this.$router.resolve(this.alternativelink.target);
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push(this.alternativelink.target);
      }
    },
    valueSlotUsed() {
      return this.$scopedSlots.value;
    }
  }
};
</script>
<style>
.details-section .profile-divider {
  margin-top: 56px;
  height: 2px;
}

.details-section.margin {
  margin-bottom: 40px;
}

.details-section .details-section-title {
  background-color: white;
  margin-bottom: 40px !important;
  margin-top: 56px !important;
}

.details-section .details-section-title .title-main {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.details-section .details-section-title .section-name {
  font-size: 24px !important;
  font-weight: 400;
}

.details-section .details-section-title .hint {
  font-size: 14px !important;
  font-weight: 400;
}

.details-section .edit-btn {
  color: #002C76;
  font-weight: 400;
  font-size: 16px !important;
  cursor: pointer;
}
</style>
